module.exports = __webpack_public_path__ + "img/br.1a4df26.png";